<template>
  <v-snackbar v-model="snackbar" :timeout="4000" bottom :color="status.type">
    <span>{{ status.message }}</span>
    <v-btn text color="white" @click="snackbar = false">
      {{ $t("app.buttons.close") }}
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    snackbar: false,
    statusColor: null
  }),
  computed: {
    ...mapState("system", ["status"])
  },
  watch: {
    status: {
      handler(val) {
        if (val.type !== "") {
          this.snackbar = true;
        }
      },
      deep: true
    }
  }
};
</script>
